import { combineReducers } from 'redux';
import * as HudlFeed from 'hudl-feed';
import featuredAthletesReducer from './featuredAthletes';
import recruiterActivityReducer from './recruiterActivity';
import exploreReducer from './explore';
import searchReducer from './search';

const feedReducers = HudlFeed.reducers;

// Combine the feed reducers with our own
const rootReducer = combineReducers(
  Object.assign({}, feedReducers, {
    explore: exploreReducer,
    featuredAthletes: featuredAthletesReducer,
    search: searchReducer,
    recruiterActivity: recruiterActivityReducer,
  }));

export default rootReducer;
